import Swiper, { Autoplay, Pagination } from 'swiper'

Swiper.use([Autoplay, Pagination])

const swiperClassNames = {
  containerModifierClass: 'brands-slider--',
  noSwipingClass: 'brands-slider--no-swiping',
  slideClass: 'brands-slider__slide',
  slideActiveClass: 'brands-slider__slide--active',
  slideNextClass: 'brands-slider__slide--next',
  slidePrevClass: 'brands-slider__slide--prev',
  slideVisibleClass: 'brands-slider__slide--visible',
  wrapperClass: 'brands-slider__wrapper',
}

export const brandsSlider = (target) => {
  const method = {
    init: () => {
      const isSwiperDisabled = target.querySelectorAll('.brands-slider__slide').length <= 1

      new Swiper(target.querySelector('.brands-slider__container'), {
        allowTouchMove: !isSwiperDisabled,
        autoplay: isSwiperDisabled
          ? false
          : {
              delay: 1500,
              disableOnInteraction: true,
            },
        grabCursor: !isSwiperDisabled,
        loop: !isSwiperDisabled,
        loopFillGroupWithBlank: true,
        pagination: {
          bulletActiveClass: 'brands-slider__pagination-bullet--active',
          bulletClass: 'brands-slider__pagination-bullet',
          bulletElement: 'button',
          clickable: true,
          el: '.brands-slider__pagination',
          renderBullet: (index, className) =>
            `<button aria-label="Vörumerki ${
              index + 1
            }" class="brands-slider__pagination-bullet ${className}">Vörumerki ${index + 1}</button>`,
          type: 'bullets',
        },
        slidesPerGroup: 3,
        slidesPerView: 'auto',
        spaceBetween: 0,
        speed: 750,
        ...swiperClassNames,
      })
    },
  }

  method.init()
}
